import EXIF from 'exif-js';

export default {
  getOrientation: (file) => {
    return new Promise((resolve) => {
      EXIF.getData(file, function() {
        const orient = EXIF.getTag(this, 'Orientation');
        resolve(orient);
      });
    });
  }
};
